import React from 'react';
import { StepperComponent } from '.'
import { StepperUtil } from '.'
import { SchoolInformationActions } from '../../../../store'
import { connect } from "react-redux";
import withAppShell from "../../../hoc/withAppShell/WithAppShell";
import routes from '../../../navigation/Routes'
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'


class EditStepperContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editStepperJsonArray: {}
        }
    }
    componentWillMount() {
        let i18n;
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            i18n = getKeyFromLS("i18n");
        } else {
            i18n = this.props.i18n
        }
        let editStepperJsonArray = StepperUtil.getEditStepperJsonArray(i18n)
        this.setState({
            editStepperJsonArray: editStepperJsonArray,
            i18n: i18n
        })
    }



    render() {
        const { i18n } = this.state

        return (
            <StepperComponent {...this.props} stepperJsonArray={this.state.editStepperJsonArray}
                stepperIndex={0}
                stepperWidth={10}
                title={this.props.activeSchool !== undefined && this.props.activeSchool.name !== "" ?
                    this.props.activeSchool.name : i18n.schoolStepper.schoolProfile}
                routeName={routes.main}
                i18n={i18n}
            />
        )



    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveSchool: (activeSchool) => dispatch(SchoolInformationActions.setActiveSchool(activeSchool))
    }
}
const mapStateToProps = (state) => {
    return {
        activeSchool: state.schoolInformation.activeSchool,
        isCreateNewSchool: state.schoolInformation.isCreateNewSchool,
        i18n: state.i18nMessages.i18n
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(EditStepperContainer))